<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Lista de Cobros Realizados</h5>
        <div class="controls-above-table">
          <div class="row">
            <div class="col-6">
              <NuevoCobroModalComponent @refresh="refreshData" />
              <a class href="#"></a>
              <a
                v-if="mostrarRefresh"
                class="btn btn-sm btn-info"
                @click="refreshData"
                href="#"
                >Refresh</a
              >
            </div>
            <div class="col-sm-12">
              <form
                action="#"
                class="form-inline justify-content-sm-end"
                @submit="filterDataSubmit"
              >
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Busca Numero o Cliente"
                  v-model="searchtext"
                  type="text"
                />
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filterTienda"
                  @change="filterData"
                >
                  <option value="">Tiendas</option>
                  <option
                    v-if="tiendas"
                    v-for="tienda in tiendas"
                    :value="tienda.codigo"
                    :key="tienda.codigo"
                  >
                    {{ tienda.nombre }}
                  </option>
                </select>
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Fecha"
                  v-model="filterFecha"
                  type="date"
                  @change="filterData"
                />
                <div class="input-group-append">
                  <button class="btn btn-link btn-sm" type="submit">
                    <i class="fa fa-search"></i>
                  </button>
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="clearFilterData"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <br />
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filterActivo"
                  @change="filterData"
                >
                  <option value="">Todos</option>
                  <option value="A">Abierto</option>
                  <option value="C">Finalizado</option>
                  <option value="9">Anulado</option>
                </select>
              </form>
            </div>
          </div>
        </div>

        <!-------------------- END - Controles arriba de tabla-------------------->
        <div 
          class="table-responsive"
        > 
          <!-------------------- Tabla de REsultados -------------------->
          <table 
            class="table table-hover"
          >
            <thead>
              <tr>
                <th>Numero</th>
                <th>Fecha</th>
                <th style="width: 120px">Tienda</th>
                <th>Caja</th>
                <th style="width: 200px">Vendedor</th>
                <th>Cliente</th>
                <th>Estado</th>
                <th style="width: 100px">Total Pagado</th>
              </tr>
            </thead>
            <tbody
              :class="{
                'loader-wrapper': !cobrosCargados,
              }"  
            >
              <!-------------------- Loader -------------------->
              <LoaderComponent
                :condicion="cobrosCargados"
              >
              </LoaderComponent>
              <!-------------------- END - Loader -------------------->
              <tr
                v-for="current in data.results"
                v-bind:key="current.id"
                @click="rowClick(current)"
              >
                <td class="text-center">{{ current.numero }}</td>
                <td>{{ current.fecha }}</td>
                <td>{{ current.tienda.nombre }}</td>
                <td>{{ current.caja.caja }}</td>
                <td>
                  <UsuarioEnTablaComponent :current="current.vendedor" />
                </td>
                <td v-if="current.cliente">
                  ({{ current.cliente.nit }}) {{ current.cliente.nombre }}
                </td>
                <td class="text-right">
                  <div
                    data-title="Activo"
                    data-toggle="tooltip"
                    v-html="current.estado_str"
                  ></div>
                </td>
                <td class="text-right">Q {{ current.total_pagado }}</td>
              </tr>
            </tbody>
          </table>
          <!-------------------- END - Basic Table -------------------->
        </div>
        <PaginationComponent
          :currentPage="currentPage"
          :data="data"
          @pagechanged="onPageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import NuevoCobroModalComponent from "@/components/cxc/cobros/NuevoCobroModalComponent";
import DynamicService from "@/services/commons/DynamicService";
import LoaderComponent from "@/components/commons/LoaderComponent.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    PaginationComponent,
    UsuarioEnTablaComponent,
    NuevoCobroModalComponent,
    LoaderComponent,
  },
  data() {
    return {
      cobrosCargados:false,
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filterActivo: "",
      filterTienda: "",
      filterFecha: "",
      data: [],
    };
  },
  computed: {
    // Esta propiedad computada generará los parámetros de filtro
    filterParams() {
      const params = {
        page: this.currentPage,
        "filter[search]": this.searchtext,
      };

      if (this.filterActivo !== "") { // Solo agrega si no es el valor por defecto "Todos"
        params.estado = this.filterActivo;
      }

      if (this.filterTienda !== "") { // Solo agrega si no es el valor por defecto "Tiendas"
        params.tienda = this.filterTienda;
      }

      if (this.filterFecha!== "") { // Solo agrega si no es el valor por defecto ""
        params.fecha = moment(this.filterFecha).format("DD/MM/YYYY");
      }else{
        delete params.fecha;
      }

      return params;
    },
    ...mapGetters({
      tiendas: "catalogos/tiendas",
    }),
  },
  mounted() {
    this.refreshTiendas();
    this.refreshData(this.filterParams);
  },
  methods: {
    refreshTiendas(){
      let self = this;
      self.$store.dispatch("catalogos/tiendas", {
        quitar_paginacion: true,
      });
    },
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "cxc-cobros-editar",
          params: { id: current.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "cxc-cobros-editar",
          params: { id: current.id },
        });
      }
    },
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData(this.filterParams);
    },
    filterData() {
      this.currentPage = 1;
      this.refreshData(this.filterParams);
    },
    filterDataSubmit(e) {
      this.filterData();
      e.preventDefault();
    },
    clearFilterData() {
      this.searchtext = "";
      this.filterActivo = "";
      this.filterTienda = "";
      this.filterFecha = "";
      this.currentPage = 1;
      this.refreshData(this.filterParams);
    },
    hide: function () {
      this.$data.destroy();
    },
    onRefreshData() {},
    refreshData(params) {
      let self = this;
      self.cobrosCargados = false;
      DynamicService.fetch("cxc", "cobros", params)
      .then((response) => {
        self.data = response.data;
        self.cobrosCargados = true;
      })
      .catch((error) => {
        console.error(error);
        this.$toast.warning("Hubo un error al cargar los datos, por favor recargue la página o comuniquese con soporte en caso siga sin cargar.","Aviso",{position: 'topRight'});
        self.cobrosCargados = true;
      });
      ;
    },
    showModalEdit() {},
  },
};
</script>
